<template>
  <div class="form-group mb-20">
    <div class="form-check custom-radio-wrapper" @click="select">
      <input
        type="radio"
        class="form-check-input d-none"
        :id="radioId"
        :checked="isSelected"
        @change="select"
      />
      <label :for="radioId" class="form-check-label">
        <img
          :src="isSelected ? checkedIcon : uncheckedIcon"
          class="custom-radio-icon"
          alt="radio"
        />
        <span class="custom-radio-label">
          <slot />
        </span>
      </label>
    </div>
    <small v-if="error" class="form-text text-error">{{ error }}</small>
    <small v-else-if="hint" class="form-text text-muted">{{ hint }}</small>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import checkedIcon from "@/assets/svg/checkbox-checked.svg";
import uncheckedIcon from "@/assets/svg/checkbox-unchecked.svg";

export default defineComponent({
  name: "AppRadio",
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      required: true,
    },
    hint: String,
    error: String,
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const radioId = computed(
      () => `radio-${Math.random().toString(36).substr(2, 9)}`
    );

    const isSelected = computed(() => props.modelValue === props.value);

    const select = () => {
      if (!isSelected.value) {
        emit("update:modelValue", props.value);
      }
    };

    return {
      radioId,
      isSelected,
      checkedIcon,
      uncheckedIcon,
      select,
    };
  },
});
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";
@import "@/styles/_input-styles.less";

.custom-radio-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;

  .form-check-label {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .custom-radio-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .custom-radio-label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.005em;
    color: @white;
    transition: color 0.2s ease;
  }
}
</style>
